import { SC } from "../helper/ServerCall";
import { pathSegment } from "../helper/queryString";

export const moreButtonService = {

    storeMoreButton,
    getMoreButton,
    updateMoreButton,
    getMoreButtonsPagination,
    deleteMoreButton,
    updateMoreButtonStatus,
    updateMoreButtonForOrder,
    storeAgencyResource,
    getAgencyResources,
    deleteAgencyResource,
    getMoreButtonsForOrder,
    getAccountMoreButtonsPagination,
    updateAccountMoreButton
}

function storeMoreButton(data) {
    return SC.postCall(`storeMoreButton`, data);
}
function getMoreButton(id) {
    return SC.getCall(`editMoreButton/${pathSegment(id)}`);
}
function updateMoreButtonStatus(moreButtonId, data) {
    return SC.putCall(`updateMoreButtonStatus/${pathSegment(moreButtonId)}`, data);
}
function storeAgencyResource(resource, id) {
    return SC.postCall(`storeAgencyResource/${pathSegment(id)}`, resource);
}

function getAgencyResources(agencyId, type) {
    return SC.getCall(`getAgencyResources/${pathSegment(agencyId)}/${pathSegment(type)}`);
}

function deleteAgencyResource(id) {
    return SC.deleteCall(`AgencyResourceDelete/${pathSegment(id)}`);
}

function updateMoreButton(data, id) {
    return SC.postCall(`updateMoreButton/${pathSegment(id)}`, data);
}
function updateAccountMoreButton(data, id) {
    return SC.postCall(`updateMoreButton/${pathSegment(id)}`, data);
}
function updateMoreButtonForOrder(data, id) {
    return SC.postCall(`updateMoreButton/${pathSegment(id)}`, data);
}
function getMoreButtonsPagination(page, filter, sort, pageSize, orderType, id) {
    return SC.postCall(`agencyMoreButtonsList/${pathSegment(id)}?page=${page}&filter=${filter}&sort=${sort}&pageSize=${pageSize}&orderType=${orderType}`);
    // return SC.postCall(`agencyMoreButtonsListTest/${id}?page=${page}&filter=${filter}&sort=${sort}&pageSize=${pageSize}&orderType=${orderType}`);
}
function getAccountMoreButtonsPagination(page, filter, sort, pageSize, orderType, id) {
    return SC.postCall(`accountMoreButtonsList/${pathSegment(id)}?page=${page}&filter=${filter}&sort=${sort}&pageSize=${pageSize}&orderType=${orderType}`);
}
function getMoreButtonsForOrder(page, filter, sort, pageSize, orderType, id, agency_id = null, uuid = null) {
    return SC.getCall(`getMoreButtonsForOrder/${pathSegment(id)}`, {
        page,
        filter,
        sort,
        pageSize,
        orderType,
        agency_id,
        uuid,
    });
}

function deleteMoreButton(id) {
    return SC.deleteCall(`deleteMoreButton/${pathSegment(id)}`);
}
